import AOS from "aos";

import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { svgInline } from "./modules/inline-svg";
import { addClass } from "./modules/add-class";
import { iframeEnhancer } from "./modules/iframe";
import { menuToggle } from "./modules/menu-toggle";
import { searchToggle } from "./modules/search-toggle";
import { followLinkAttribute } from "./modules/follow_data_link";
import { filtersOnChange, masonry, masonrySF } from "./modules/masonry";
import {
    articleInView,
    closeOverlay,
    countViewedArticles,
    filterInit,
    misterMotleyAds,
    misterMotleyArticleActions,
    misterMotleyFixOldArticles,
    misterMotleyRemoveFavorite,
    misterMotleyViewer,
    observeArticles,
    popupProductLink,
    removeFilter,
    showNewsletter,
} from "./modules/mister-motley";
import { tuckIn, tuckOut } from "./modules/tuck-in";
import {adsCarrousel, carrousel} from "./modules/carrousel";
import { scroll } from "./modules/scroll";
import { copyToClipboard } from "./modules/copy-to-clipboard";
import { scPlayer } from "./modules/sc-player";
import { loadNext } from "./modules/load-next";

window.mmEnhancers = {
    svgInline,
    addClass,
    iframeEnhancer,
    menuToggle,
    searchToggle,
    masonry,
    masonrySF,
    misterMotleyViewer,
    tuckIn,
    tuckOut,
    scroll,
    carrousel,
    adsCarrousel,
    misterMotleyArticleActions,
    misterMotleyFixOldArticles,
    misterMotleyRemoveFavorite,
    misterMotleyAds,
    scPlayer,
    filtersOnChange,
    filterInit,
    loadNext,
    articleInView,
    observeArticles,
    countViewedArticles,
    showNewsletter,
};

window.mmHandlers = {
    addClass,
    copyToClipboard,
    followLinkAttribute,
    removeFilter,
    closeOverlay,
    popupProductLink,
};

onDomReady(() => {
    enhance(document.documentElement, window.mmEnhancers);
    handle(document.documentElement, window.mmHandlers);

    AOS.init();
});
